import { Component, Inject, OnInit, ViewChild , EventEmitter} from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from  '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_698';  

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Valor venta', listHelp: ['751'] },
  { text: "2", active: false, completed: false, tooltip: 'Valor compra', listHelp: ['753'] },
  { text: "3", active: false, completed: false, tooltip: 'Valor declarado año anterior', listHelp: ['754'] },
  { text: "4", active: false, completed: false, tooltip: 'Valor mejoras', listHelp: ['759'] },
  { text: "5", active: false, completed: false, tooltip: 'Casa nacional', listHelp: [''] },
  { text: "6", active: false, completed: false, tooltip: 'Valor catastral año anterior', listHelp: ['755'] },
  { text: "7", active: false, completed: false, tooltip: 'Impuesto exterior', listHelp: ['794'] },
  { text: "8", active: false, completed: false, tooltip: 'AFC', listHelp: ['761'] },
  { text: "9", active: false, completed: false, tooltip: 'Valor catastral año', listHelp: ['762'] },
  { text: "10", active: false, completed: false, tooltip: 'Renta', listHelp: ['757'] },
  { text: "11", active: false, completed: false, tooltip: 'Costo', listHelp: [''] }
];

class ArticulosDominio {
  valor: number;
  nombre: string;
}
@Component({
  selector: 'app-ganancias-ocasionales-casa-modal',
  templateUrl: './ganancias-ocasionales-casa-modal.component.html',
  styleUrls: ['./ganancias-ocasionales-casa-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class GananciasOcasionalesCasaModalComponent extends HandlerModal implements OnInit {

  @ViewChild('buttonRight') buttonRight: any;
  saveModel = new EventEmitter();
  public selCostoDecl: ArticulosDominio[] = [];
  tablaArt73:any;
  public showSave:boolean;
  public lstAnios: number[] = [];
  public lstArticulos: ArticulosDominio[] = [];

  constructor(
    public dialogRef: MatDialogRef<GananciasOcasionalesCasaModalComponent>,
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);
    console.log(model);
  }

  ngOnInit() {
    this.inicializeModelo();
    this.validateBtnRightActive();
    this.initializeArticulos('0');
    this.initializeAnios();
    this.validateShowSave();
  }

  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cs_id_751 == undefined)this.model.doc.cuerpo.cs_id_751="0";
    if(this.model.doc.cuerpo.cs_id_752 == undefined)this.model.doc.cuerpo.cs_id_752="0";
    if(this.model.doc.cuerpo.cs_id_753 == undefined)this.model.doc.cuerpo.cs_id_753="0";  
    if(this.model.doc.cuerpo.cs_id_754 == undefined)this.model.doc.cuerpo.cs_id_754="0";  
    if(this.model.doc.cuerpo.cs_id_759 == undefined)this.model.doc.cuerpo.cs_id_759="0";
    if(this.model.doc.cuerpo.cs_id_760 == undefined)this.model.doc.cuerpo.cs_id_760="0";
    if(this.model.doc.cuerpo.cs_id_755 == undefined)this.model.doc.cuerpo.cs_id_755="0";
    if(this.model.doc.cuerpo.cs_id_794 == undefined)this.model.doc.cuerpo.cs_id_794="0";
    if(this.model.doc.cuerpo.cs_id_795 == undefined)this.model.doc.cuerpo.cs_id_795="0";
    if(this.model.doc.cuerpo.cs_id_762 == undefined)this.model.doc.cuerpo.cs_id_762="0";
    if(this.model.doc.cuerpo.cs_id_758 == undefined)this.model.doc.cuerpo.cs_id_758="0";
    if(this.model.doc.cuerpo.cs_id_763 == undefined)this.model.doc.cuerpo.cs_id_763="0";
    if(this.model.doc.cuerpo.cs_id_796 == undefined)this.model.doc.cuerpo.cs_id_796="0";
    if(this.model.doc.cuerpo.cs_id_795 == undefined)this.model.doc.cuerpo.cs_id_795="0";
    if(this.model.doc.cuerpo.cs_id_797 == undefined)this.model.doc.cuerpo.cs_id_797="0";
    if(this.model.doc.cuerpo.cs_id_670 == undefined)this.model.doc.cuerpo.cs_id_670="0";
    if(this.model.doc.cuerpo.cs_id_793 == undefined)this.model.doc.cuerpo.cs_id_793= null;
    if(this.model.doc.cuerpo.cs_id_761 == undefined)this.model.doc.cuerpo.cs_id_761= null;
    if(this.model.doc.cuerpo.cs_id_757 == undefined)this.model.doc.cuerpo.cs_id_757= null;
    
    this.reloadSelArticulos();
   
  }
  protected initializeArticulos(val:string ){
    const cas753 = this.model.doc.cuerpo.cs_id_753; 
      const cas754 = this.model.doc.cuerpo.cs_id_754; 
      const cas758 = this.model.doc.cuerpo.cs_id_758;  //valor ajustado
    if (val == "0"){
      
        this.selCostoDecl[0] = {valor:2,nombre:"Valor Compra $" + cas753};
        this.selCostoDecl[1] = {valor:3,nombre:"Valor Declarado Año Anterior $" + cas754};
       
    }else{
      this.selCostoDecl = [];
      this.selCostoDecl[0] = {valor:5,nombre:"Valor Ajustado art.73 &" + cas758};
        
    }
    if(val!=undefined && val!=""){
      this.buttonRight.nativeElement.disabled = false;
    }
  }

  protected initializeAnios(){
    for(let i=0; i<this.tablaArt73.length;i++){
      if( Number(this.tablaArt73[i].anio) != 2020 &&
      Number(this.tablaArt73[i].anio) != 2021 && Number(this.tablaArt73[i].anio) != 2022 
   ){
      this.lstAnios[i]=Number(this.tablaArt73[i].anio);
      }
    }
  }

  public calcularValoresForm(conservarArt?:boolean){
   // this.redondearFormData();
    //this.modelForm.valAjustadoArt70 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelForm.valDeclaradoAnioAnterior.toString(), "1.0467",true);
    //this.modelForm.valAjustadoArt70 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt70.toString(),true);
    if(this.model.doc.cuerpo.cs_id_757=="1"){
      let registroArt73 = this.tablaArt73.find((ite: any) => this.model.doc.cuerpo.cs_id_752== ite.anio);
      let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.model.doc.cuerpo.cs_id_753.toString(), registroArt73.bienes.toString(),false);
      this.model.doc.cuerpo.cs_id_758 = resultado;
      this.model.doc.cuerpo.cs_id_758 = this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_758.toString(),true);
      console.log("Factor  registroArt73 es: " + registroArt73  + " Y el valor ajustado. " +  this.model.doc.cuerpo.cs_id_758  );
    }else{
      this.model.doc.cuerpo.cs_id_758 = "0";
    }
    this.GenerarCombo();
    //this.modelForm.valAjustadoArt73 = this.dutilidades.redondearValorMoneda(this.modelForm.valAjustadoArt73.toString(),true);
    /**
    switch(Number(this.modelForm.art)){
      case 1:
        this.modelForm.valDeclarar = this.modelForm.valCatastral.toString();
        break;
      case 2:
        this.modelForm.valDeclarar = this.modelForm.valCompra.toString();
        break;
      case 3:
        this.modelForm.valDeclarar = this.modelForm.valDeclaradoAnioAnterior.toString();
        break;
      case 4:
        this.modelForm.valDeclarar = this.modelForm.valAjustadoArt70.toString();
        break;
      case 5:
        this.modelForm.valDeclarar = this.modelForm.valAjustadoArt73.toString();
        break;  
      default:
        this.modelForm.valDeclarar = "0";      
    }
    this.modelForm.valDeclarar = this.dutilidades.redondearValorMoneda(this.modelForm.valDeclarar.toString(),true);
    this.reloadSelArticulos(conservarArt);
     */
    this.reloadSelArticulos(conservarArt);
  }

  //////////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {
    console.log(this.indexStepper + " - " +val);
    switch (this.indexStepper) {
      case 4:
        if(this.validateHasModalValues(this.indexStepper,val)){
          this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Esta cambiando su respuesta a '" + (val=="1"?"SI":"NO") + "', sin embargo se encontraron datos diligenciados para sus respuestas, si confirma se eliminarán las respuestas ingresadas para esta pregunta ¿Desea confirmar?").afterClosed().subscribe(result => {
            if (result) {
              this.cleanModalValues(this.indexStepper,val);
              this.model.doc.cuerpo.cs_id_793 = val;
              //this.changeStepLocal(this.indexStepper+2);
            }
          });
        }else{
          this.model.doc.cuerpo.cs_id_793 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      case 7:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_761 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_761 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_761 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;

      
      case 9:
        if(val == "0"){
          if(this.validateHasModalValues(this.indexStepper)){
            this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
              if (result) {
                this.cleanModalValues(this.indexStepper);
                this.model.doc.cuerpo.cs_id_757 = val;
                //this.changeStepLocal(this.indexStepper+2);
              }
            });
          }else{
            this.model.doc.cuerpo.cs_id_757 = val;
          }
        }else{
          this.model.doc.cuerpo.cs_id_757 = val;
        }

        //Si ha seleccionado respuesta SI/NO habilitar botón next
        if(val!=undefined && val!=""){
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
    }
    console.log(this.model);
  }

  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number, val?:string): boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){//Pregunta Actualizar 
      case 4:
        if(val=="0"){
          if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_755, "0")){hasValues=true;}
        }
        if(val=="1"){
          if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_794, "0")){hasValues=true;}
        }
        break;
      case 7:
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_762, "0")){
          hasValues=true;
        }
        break;
    }
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number, val?:string){
    switch(indexQuestionModal){
      case 4:
        if(val=="0"){
          this.model.doc.cuerpo.cs_id_755 = "0";
        }
        if(val=="1"){
          this.model.doc.cuerpo.cs_id_794 = "0";
          this.model.doc.cuerpo.cs_id_795 = "0";
        }
        break;
      case 7:
        this.model.doc.cuerpo.cs_id_762="0";
        break;
      default:
        break;
    }
    console.log(this.model);
  }
  
  //Aplica si dentro del modal existen conchangeStepLocaldiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    //Si no ha respondido en go15CasaNacional no puede saltar preguntas
    if( (indexS>=5 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_793==undefined || this.model.doc.cuerpo.cs_id_793=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en go15CasaNacional debe saltar preguntas del indexStepper
    else if( (indexS==5 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_793=="0")) ){
      habilitado = false;
    }
    //Si no ha respondido en go16CasaAFC no puede saltar preguntas
    if( (indexS>=8 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_761==undefined || this.model.doc.cuerpo.cs_id_761=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en go16CasaAFC debe saltar preguntas del indexStepper
    else if( (indexS==8 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_761=="0")) ){
      habilitado = false;
    }

     //Si no ha respondido en go17RentaAnterior no puede saltar preguntas
    if( (indexS>=6 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_793==undefined || this.model.doc.cuerpo.cs_id_793=="")) ){
      habilitado = false;
    }
    //Si responde 'NO' en go17RentaAnterior debe saltar preguntas del indexStepper
    else if( (indexS==6 && indexS<=stepsList.length && (this.model.doc.cuerpo.cs_id_793=="1")) ){
      habilitado = false; 
    } 
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){
    //Si no se ha seleccionado respuesta SI/NO en go15CasaNacional deshabilitar botón next
    switch(this.indexStepper){
      case 4:
        //Si no se ha seleccionado respuesta SI/NO en go15CasaNacional deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_793==undefined || this.model.doc.cuerpo.cs_id_793=="" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      case 7:
        //Si no se ha seleccionado respuesta SI/NO en go15CasaNacional deshabilitar botón next
        if( this.model.doc.cuerpo.cs_id_761==undefined || this.model.doc.cuerpo.cs_id_761=="" ){
          this.buttonRight.nativeElement.disabled = true;  
        }else{
          this.buttonRight.nativeElement.disabled = false;
        }
        break;
      default:
        this.buttonRight.nativeElement.disabled = false;
        break;
    }
  }
  


  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  
  protected updateIndicadorAvance(){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    }
  }

  protected controlStep(direction: DirectionType): void {
    let indexS = this.indexStepper;
    while(!this.validateStepHabilitado(indexS)){
      if(direction==DirectionType.previous ){
          indexS--;
      }
      if(direction==DirectionType.next){
          indexS++;
      }
    }
    this.changeStepLocal(indexS, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
    let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave();
  }

  public operaciones(numCas?:number,soloEstaCasilla?:boolean):void {
    switch (numCas) {
     
      case 670: this.OperacionCs670(); break;
      case 751: this.OperacionCs751(); break;
      case 752: this.OperacionCs752(); break;
      case 753: this.OperacionCs753(); break;
      case 754: this.OperacionCs754(); break;
      case 755: this.OperacionCs755(); break;
      case 757: this.OperacionCs757(); break;
      //case 758: this.OperacionCs758(); break;
      case 759: this.OperacionCs759(); break;
      case 760: this.OperacionCs760(); break;
      case 761: this.OperacionCs761(); break;
      case 762: this.OperacionCs762(); break;
      case 793: this.OperacionCs793(); break;
      case 794: this.OperacionCs794(); break;
      case 795: this.OperacionCs795(); break;
      

             
   }
    if(soloEstaCasilla)return;

    //Operaciones3
    let resultado = "0";
    
  }
  
 
//valor venta de la casa
OperacionCs751() {
  this.model.doc.cuerpo.cs_id_751=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_751,true);
	const cas751 = this.model.doc.cuerpo.cs_id_751;
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas751,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("El valor de venta de la casa no puede ser cero");
	  return
   }
   this.OperacionCs797();
   this.OperacionCs784();
}

//valor compra de la casa
OperacionCs753() {
	this.model.doc.cuerpo.cs_id_753=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_753,true);
	const cas753 = this.model.doc.cuerpo.cs_id_753
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas753,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("El valor de compra de la casa no puede ser cero");
	  return
   }
   this.GenerarCombo();
   this.OperacionCs797();
   this.calcularValoresForm();
   
}

//año de compra de la casa
OperacionCs752() {
	const cas752 = this.model.doc.cuerpo.cs_id_752;
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas752,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("El año de compra de la casa no puede ser cero");

	  return
   }
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas752,"1900")
   || this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas752,"2022")
   ) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("Valor año de compra de compra no es un año válido.");

	  return
   }
   this.calcularValoresForm();
   this.OperacionCs797();
}
//let registroArt73 = this.tablaArt73.find((ite: any) => this.modelForm.anioCompra == ite.anio);
//valor declarado año anterior
OperacionCs754(){
	// no tiene validaciones
  this.model.doc.cuerpo.cs_id_754=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_754,true);
	
	this.GenerarCombo();
}

//valor de las mejoras
OperacionCs759(){
	// no tiene validaciones
  this.model.doc.cuerpo.cs_id_759=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_759,true);
	this.OperacionCs760();
  this.calcularValoresForm();
}

//la casa vendida está en Colombia ?
OperacionCs793(){
	const cas793 = this.model.doc.cuerpo.cs_id_793; 
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas793,"1")) {
		this.model.doc.cuerpo.cs_id_794="0"; //impuesto pagado en el exterior
  }
	else {
		this.model.doc.cuerpo.cs_id_755="0";	 //valor catastral 
	}
}

//valor avaluo año 2021
OperacionCs755() {
  this.model.doc.cuerpo.cs_id_755=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_755,true);
	const cas755 = this.model.doc.cuerpo.cs_id_755
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas755,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("El valor del avalúo de la casa para el año 2021 no puede ser cero");
	  return
   }
   this.calcularValoresForm();
   this.GenerarCombo();
}

//valor impuesto pagado en el exterior
OperacionCs794(){
	// no tiene validaciones
  this.model.doc.cuerpo.cs_id_794=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_794,true);
	this.OperacionCs795(); //limite impuesto pag exterior venta casa.. 
  this.calcularValoresForm();
}


//dineros de la venta fueron consignados en cuenta AFC ?
OperacionCs761(){
  this.model.doc.cuerpo.cs_id_761=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_761,true);
	const cas761 = this.model.doc.cuerpo.cs_id_761;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas761,"0")) {
		this.model.doc.cuerpo.cs_id_762="0";
	}
	this.OperacionCs797(); //renta excenta
  this.calcularValoresForm();
}


//valor avaluo año 2022
OperacionCs762() {
  this.model.doc.cuerpo.cs_id_762=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_762,true);
	const cas762 = this.model.doc.cuerpo.cs_id_762
   if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas762,"0")) {
	  this.dNotificacionServicio.mostrarDialogoInformacion("El valor del avalúo de la casa para el año 2022 no puede ser cero");
	  return;
   }
	this.OperacionCs797();
  this.calcularValoresForm();
}


//Aplicó art. 73?
OperacionCs757(){
	const cas757 = this.model.doc.cuerpo.cs_id_757;
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas757,"0")) {
		this.model.doc.cuerpo.cs_id_758="0";
	} else {
		this.calcularValoresForm(); //valor ajustado art 
	}
  
	this.GenerarCombo();
}

protected reloadSelArticulos(conservarArt?:boolean){//Dom 1649
    
  this.lstArticulos[0] = {valor:0,nombre:""};
  this.lstArticulos[0] = {valor:1,nombre:"Valor avalúo año anterior"};
  this.lstArticulos[1] = {valor:2,nombre:"Valor Compra"};
  this.lstArticulos[2] = {valor:3,nombre:"Valor declarado año anterior"};
  this.lstArticulos[3] = {valor:4,nombre:"Valor ajustado art. 70"};
  this.lstArticulos[4] = {valor:5,nombre:"Valor ajustado art. 73"};
  
  if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_755,  this.model.doc.cuerpo.cs_id_753) 
      && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_755,  this.model.doc.cuerpo.cs_id_754)
      && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_755,  this.model.doc.cuerpo.cs_id_758)){
        this.lstArticulos = [];
        this.lstArticulos[0] = {valor:0,nombre:""};
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_755, "0"))
          this.lstArticulos[1] = {valor:1,nombre:("Valor avalúo año anterior: $"+this.model.doc.cuerpo.cs_id_755)};
  }else{
    this.lstArticulos = [];
    let i=0;
    this.lstArticulos[i] = {valor:0,nombre:""};
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_755, "0")){
      i++
      this.model.doc.cuerpo.cs_id_755=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_755,true);
      this.lstArticulos[i] = {valor:1,nombre:("Valor avalúo año anterior: $"+this.model.doc.cuerpo.cs_id_755)};
    }
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,this.model.doc.cuerpo.cs_id_753, "0")){
      i++;
      this.model.doc.cuerpo.cs_id_753=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_753,true);
      this.lstArticulos[i] = {valor:2,nombre:("Valor Compra: $"+ this.model.doc.cuerpo.cs_id_753)};
    }
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,this.model.doc.cuerpo.cs_id_754, "0")){
      i++;
      this.model.doc.cuerpo.cs_id_754=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_754,true);
      this.lstArticulos[i] = {valor:3,nombre:("Valor declarado año anterior: $"+this.model.doc.cuerpo.cs_id_754)};
    }
    //Valor ajustado
    if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_758, "0")){
      i++;
      this.model.doc.cuerpo.cs_id_758=this.dutilidades.redondearValorMoneda(this.model.doc.cuerpo.cs_id_758,true);
      this.lstArticulos[i] = {valor:5,nombre:("Valor ajustado art. 73: $"+ this.model.doc.cuerpo.cs_id_758)};
    }
  }
  //if(!conservarArt)this.modelForm.art=0;
}
//valor ajustado art. 73 se cambia por this.calcularValoresForm()
/** 
OperacionCs758(){
	const cas752 = this.model.doc.cuerpo.cs_id_752;
	const cas753 = this.model.doc.cuerpo.cs_id_753;
  const cas758 = this.model.doc.cuerpo.cs_id_758;
	
	//esta consulta la implementó Jonathan. preguntar para habilitarla
	const factorAjuste = "1"; ; //TablaArt73(cas752);  *** Ojo cambiar!!!!

	const resultado =  this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,cas753,factorAjuste);
	this.model.doc.cuerpo.cs_id_758 = this.dutilidades.redondearValorMoneda(resultado ,true); 

}
*/

//costo fiscal etiqueta + valor
OperacionCs670(){
	this.OperacionCs760();
}

GenerarCombo() {

  this.reloadSelArticulos();
	
}
//costo fiscal 

OperacionCs760(){
  
  let selValArt = "0";
  if(this.model.doc.cuerpo.cs_id_670=="1"){
    selValArt = this.model.doc.cuerpo.cs_id_755;
  }else if(this.model.doc.cuerpo.cs_id_670=="2"){
    selValArt = this.model.doc.cuerpo.cs_id_753;
  }else if(this.model.doc.cuerpo.cs_id_670=="3"){
    selValArt = this.model.doc.cuerpo.cs_id_754;
  }else if(this.model.doc.cuerpo.cs_id_670=="5"){
    selValArt = this.model.doc.cuerpo.cs_id_758;
  }//"4" no aplica

  const cas759 = this.model.doc.cuerpo.cs_id_759;   //mejoras
  
  this.model.doc.cuerpo.cs_id_760 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,selValArt,cas759);
  this.OperacionCs797();
  this.OperacionCs784();
}

//Calculo de impuesto de ganacia ocasional al 10%
OperacionCs785(){
	//validacion pendiente
}

//Calculo de impuesto de ganacia ocasional al 20%
OperacionCs784(){
//validacion pendiente
}

//limite impuesto pagado en colombia
OperacionCs795(){
	const cas794 = this.model.doc.cuerpo.cs_id_794; //impuesto pagado en el exterior por la venta
	if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas794,"0")) {
		
		const cas751 = this.model.doc.cuerpo.cs_id_751; //valor venta 
		const cas760 = this.model.doc.cuerpo.cs_id_760;// costo fiscal . 
		
		let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,cas751,cas760);
		if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,resultado,"0")) {
			resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.1"); //resta de la venta - costo fiscal *  0.1
			
			if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE,cas794,resultado)) { //si el imp exterior es mayor quel impuesto local el limite es el resultado
				this.model.doc.cuerpo.cs_id_795 = resultado;
			} else {
				this.model.doc.cuerpo.cs_id_795 = cas794; // si el imp exterior es menor que resultado  el limite es  el valor del imp
			}			
		} else {
		    this.model.doc.cuerpo.cs_id_795 = "0";
		}
	}
}

  //rentas exentas
OperacionCs797(){
	const cas751 = this.model.doc.cuerpo.cs_id_751; //venta
	const cas760 = this.model.doc.cuerpo.cs_id_760; // costo fiscal mas mejoras
	const cas752 = this.model.doc.cuerpo.cs_id_752; //año compra
  const cas761 = this.model.doc.cuerpo.cs_id_761; // ?? cuanta AFC
  const cas762 = this.model.doc.cuerpo.cs_id_762; // Avaluo

	
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas751,"0") || 
	   this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas760,"0") || 
	   this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas752,"0")) {
		
		this.model.doc.cuerpo.cs_id_797="0";  //renta excenta
		this.model.doc.cuerpo.cs_id_796="0";  //utilidad de art 
		this.model.doc.cuerpo.cs_id_763="0";  // Renta exenta del art 311
		return;
	}
	
	let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,cas751,cas760);
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,resultado,"0")) {
		this.model.doc.cuerpo.cs_id_797="0";
		this.model.doc.cuerpo.cs_id_796="0";
		this.model.doc.cuerpo.cs_id_763="0";
		return ;
    }

    let rentaExenta = "0";
	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas752,"1977")) {

		this.model.doc.cuerpo.cs_id_797 = resultado;
		this.model.doc.cuerpo.cs_id_796 = "0";
		this.model.doc.cuerpo.cs_id_763 = resultado;
	 	return;
		
    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas752,"1978")) {
		rentaExenta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.9");

    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas752,"1979")) {
		rentaExenta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.8");

    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas752,"1980")) {
		rentaExenta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.7");

    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas752,"1981")) {
		rentaExenta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.6");

    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas752,"1982")) {
		rentaExenta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.5");

    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas752,"1983")) {
		rentaExenta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.4");

    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas752,"1984")) {
		rentaExenta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.3");

    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas752,"1985")) {
		rentaExenta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.2");

    } else if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas752,"1986")) {
		rentaExenta = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,resultado,"0.1"  );

    }else{
		rentaExenta = "0";
    }

	this.model.doc.cuerpo.cs_id_797 = this.dutilidades.redondearValorMoneda(rentaExenta,true);
	
	resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.RESTA,resultado,rentaExenta);
  resultado = this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,resultado,"0")?"0":resultado;
	this.model.doc.cuerpo.cs_id_796 = resultado;
	
	const uvt15000 = "570060000";	

	if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES,cas761,"1") &&
	   this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,cas762,uvt15000)) {
		   
			const uvt7500 ="285030000";
			
			if (this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MENOR_O_IGUAL_QUE,resultado,uvt7500)) {
				this.model.doc.cuerpo.cs_id_763 = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,resultado,this.model.doc.cuerpo.cs_id_763);
      }else {
				this.model.doc.cuerpo.cs_id_763 = uvt7500;
		   }
	} else {
		this.model.doc.cuerpo.cs_id_763 = rentaExenta;
    this.model.doc.cuerpo.cs_id_796 = "0";
	}
}   


  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.changeStepLocal(0);
    this.dialogRef.close("");
  }
  public guardar(){
    this.saveModel.emit(true);
    if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    }
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-casa-modal/ganancias-ocasionales-casa-modal.component.ts